(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["pl-brand-builder"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('pl-brand-builder')) {
    customElements.define(
      'pl-brand-builder',
      class extends HTMLElement {
        connectedCallback() {
          this.form = this.closest('form');
          this.steps = [...this.querySelectorAll('[data-step]')];
          this.dots = [...this.querySelectorAll('[data-goto]')];
          this.current = 0;
          this.reached = 0;
          this.distribute();
          this.abort = new AbortController();
          const { signal } = this.abort;
          this.addEventListener('change', this.onChange, { signal });
          this.addEventListener('click', this.onClick, { signal });
          this.form?.addEventListener('submit', this.onSubmit, { signal });
          this.toggleConditional();
          this.show(0, false);
          this.updateSummary();
        }

        disconnectedCallback() {
          this.abort?.abort();
        }

        /* Move the catalogue blocks into the grid of their kind. */
        distribute() {
          for (const item of this.querySelectorAll('[data-pl-bb-pool] [data-kind]')) {
            this.querySelector(`[data-pl-bb-grid="${item.dataset.kind}"]`)?.append(item);
          }
        }

        get need() {
          return this.querySelector('input[data-need]:checked')?.dataset.need || '';
        }

        get activeSteps() {
          return this.steps.filter((step) => !step.dataset.skipNeed || step.dataset.skipNeed !== this.need);
        }

        toggleConditional() {
          for (const el of this.querySelectorAll('[data-show-need]')) {
            el.hidden = el.dataset.showNeed !== this.need;
          }
          for (const [index, step] of this.steps.entries()) {
            const li = this.dots[index]?.closest('li');
            if (li) li.hidden = !this.activeSteps.includes(step);
          }
        }

        show(position, scroll = true) {
          const active = this.activeSteps;
          position = Math.max(0, Math.min(position, active.length - 1));
          this.current = position;
          this.reached = Math.max(this.reached, position);
          const step = active[position];
          for (const s of this.steps) s.hidden = s !== step;
          for (const [index, dot] of this.dots.entries()) {
            const pos = active.indexOf(this.steps[index]);
            dot.classList.toggle('is-current', pos === position);
            dot.classList.toggle('is-done', pos > -1 && pos < position);
            dot.disabled = pos === -1 || pos > this.reached;
            dot.querySelector('.pl-bb__dot-num').textContent = pos > -1 ? pos + 1 : '';
            if (pos === position) dot.setAttribute('aria-current', 'step');
            else dot.removeAttribute('aria-current');
          }
          const last = position === active.length - 1;
          this.querySelector('[data-pl-bb-back]').hidden = position === 0;
          this.querySelector('[data-pl-bb-next]').hidden = last;
          this.querySelector('[data-pl-bb-submit]').hidden = !last;
          this.querySelector('[data-pl-bb-bar]').style.width = `${((position + 1) / active.length) * 100}%`;
          this.querySelector('[data-pl-bb-count]').textContent = `${position + 1} / ${active.length}`;
          this.toggleAttribute('data-last', last);
          this.setError('');
          if (scroll) this.scrollIntoView({ behavior: 'smooth', block: 'start' });
        }

        /* ---------- validation ---------- */
        validate(step) {
          let first = null;
          for (const group of step.querySelectorAll('[data-required]')) {
            if (group.closest('[hidden]') && group.closest('[hidden]') !== step) continue;
            let ok;
            if (group.matches('label') && group.querySelector('input[type="checkbox"]') && !group.querySelector('input[type="text"]')) {
              ok = group.querySelector('input').checked;
            } else if (group.querySelector('input[type="radio"], input[type="checkbox"]')) {
              ok = Boolean(group.querySelector('input:checked'));
            } else {
              const field = group.querySelector('input, textarea');
              ok = field ? field.checkValidity() : true;
            }
            group.classList.toggle('is-invalid', !ok);
            if (!ok && !first) first = group;
          }
          if (first) {
            this.setError(this.dataset.requiredText);
            first.scrollIntoView({ behavior: 'smooth', block: 'center' });
            first.querySelector('input, textarea')?.focus({ preventScroll: true });
            return false;
          }
          this.setError('');
          return true;
        }

        setError(text) {
          const el = this.querySelector('.pl-bb__step-error');
          el.textContent = text;
          el.hidden = !text;
        }

        /* ---------- summary ---------- */
        valuesOf(el) {
          if (el.matches('input, textarea')) return el.value.trim() ? [el.value.trim()] : [];
          return [...el.querySelectorAll('input:checked')].map((input) => input.value);
        }

        updateSummary() {
          const list = this.querySelector('[data-pl-bb-summary]');
          list.replaceChildren();
          const active = this.activeSteps;
          let rows = 0;
          for (const el of this.querySelectorAll('[data-summary]')) {
            const step = el.closest('[data-step]');
            if (!active.includes(step) || (el.closest('[hidden]') && el.closest('[hidden]') !== step)) continue;
            const values = this.valuesOf(el);
            if (!values.length || !el.dataset.summary) continue;
            const dt = document.createElement('dt');
            dt.textContent = el.dataset.summary;
            const dd = document.createElement('dd');
            dd.textContent = values.join(', ');
            list.append(dt, dd);
            rows += 1;
          }
          this.querySelector('[data-pl-bb-empty]').hidden = rows > 0;

          const combo = this.querySelector('[data-pl-bb-combo]');
          let any = false;
          for (const slot of combo.querySelectorAll('[data-slot-img]')) {
            const kind = slot.dataset.slotImg;
            const img = this.querySelector(`[data-pl-bb-grid="${kind}"] input:checked`)?.closest('label')?.querySelector('img');
            slot.replaceChildren();
            if (img && this.need !== 'oil') {
              const copy = document.createElement('img');
              copy.src = img.currentSrc || img.src;
              copy.alt = img.alt;
              slot.append(copy);
              any = true;
            }
          }
          combo.hidden = !any;
        }

        /* Checkbox groups have no name: join them into one field each. */
        compose() {
          const holder = this.querySelector('[data-pl-bb-hidden]');
          holder.replaceChildren();
          const active = this.activeSteps;
          for (const group of this.querySelectorAll('[data-group]')) {
            const step = group.closest('[data-step]');
            if (!active.includes(step) || group.hidden) continue;
            const values = [...group.querySelectorAll('input:checked')].map((input) => input.value);
            if (!values.length) continue;
            const input = document.createElement('input');
            input.type = 'hidden';
            input.name = `contact[${group.dataset.group}]`;
            input.value = values.join(', ');
            holder.append(input);
          }
          for (const step of this.steps) {
            const skip = !active.includes(step);
            for (const field of step.querySelectorAll('input, textarea')) field.disabled = skip;
          }
        }

        /* ---------- events ---------- */
        next() {
          const step = this.activeSteps[this.current];
          if (this.validate(step)) this.show(this.current + 1);
        }

        onClick = (event) => {
          const target = event.target instanceof Element ? event.target : null;
          if (!target) return;
          if (target.closest('[data-pl-bb-next]')) this.next();
          else if (target.closest('[data-pl-bb-back]')) this.show(this.current - 1);
          else {
            const dot = target.closest('[data-goto]');
            if (dot && !dot.disabled) {
              const pos = this.activeSteps.indexOf(this.steps[Number(dot.dataset.goto)]);
              if (pos > -1 && pos <= this.reached) this.show(pos);
            }
          }
        };

        onChange = (event) => {
          const target = event.target;
          if (target.matches?.('[data-need]')) {
            this.toggleConditional();
            this.show(this.current, false);
          }
          target.closest?.('.is-invalid')?.classList.remove('is-invalid');
          this.updateSummary();
        };

        onSubmit = (event) => {
          const active = this.activeSteps;
          if (this.current < active.length - 1) {
            event.preventDefault();
            this.next();
            return;
          }
          if (!this.validate(active[this.current])) {
            event.preventDefault();
            return;
          }
          this.compose();
          const button = this.querySelector('[data-pl-bb-submit]');
          button.classList.add('is-loading');
        };
      }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["pl-collection"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('pl-collection')) {
    customElements.define(
      'pl-collection',
      class extends HTMLElement {
        connectedCallback() {
          this.items = [...this.querySelectorAll('[data-pl-item]')];
          this.grid = this.querySelector('[data-pl-grid]');
          this.step = Number(this.dataset.step) || 24;
          this.shown = this.step;
          try {
            this.strings = JSON.parse(this.parentElement.querySelector('[data-pl-strings]')?.innerHTML || '{}');
          } catch {
            this.strings = {};
          }
          this.abort = new AbortController();
          const { signal } = this.abort;
          this.addEventListener('change', this.onChange, { signal });
          this.addEventListener('click', this.onClick, { signal });
          this.addEventListener('keydown', this.onKeydown, { signal });
          this.countOptions();
          this.readUrl();
          this.apply(false);
        }

        disconnectedCallback() {
          this.abort?.abort();
          document.documentElement.classList.remove('pl-coll-lock');
        }

        /* ---------- state ---------- */
        checked(name) {
          return [...this.querySelectorAll(`input[name="${name}"]:checked`)].map((input) => input.value);
        }

        number(selector) {
          const input = this.querySelector(selector);
          if (!input || input.value === '') return null;
          const value = Number(input.value);
          return Number.isFinite(value) ? value : null;
        }

        get state() {
          return {
            familia: this.checked('familia'),
            publico: this.checked('publico'),
            min: this.number('[data-pl-min]'),
            max: this.number('[data-pl-max]'),
            stock: Boolean(this.querySelector('input[name="stock"]:checked')),
            orden: this.querySelector('[data-pl-sort]')?.value || '',
          };
        }

        readUrl() {
          const params = new URLSearchParams(window.location.search);
          for (const name of ['familia', 'publico']) {
            const values = (params.get(name) || '').split(',').filter(Boolean);
            for (const input of this.querySelectorAll(`input[name="${name}"]`)) {
              input.checked = values.includes(input.value);
            }
          }
          const min = this.querySelector('[data-pl-min]');
          const max = this.querySelector('[data-pl-max]');
          if (min) min.value = params.get('min') || '';
          if (max) max.value = params.get('max') || '';
          const stock = this.querySelector('input[name="stock"]');
          if (stock) stock.checked = params.get('stock') === '1';
          const sort = this.querySelector('[data-pl-sort]');
          if (sort) sort.value = params.get('orden') || '';
        }

        writeUrl(state) {
          const url = new URL(window.location.href);
          const set = (key, value) => (value ? url.searchParams.set(key, value) : url.searchParams.delete(key));
          set('familia', state.familia.join(','));
          set('publico', state.publico.join(','));
          set('min', state.min ?? '');
          set('max', state.max ?? '');
          set('stock', state.stock ? '1' : '');
          set('orden', state.orden);
          window.history.replaceState(window.history.state, '', url);
        }

        /* ---------- filtering ---------- */
        matches(item, state, skip) {
          const tags = item.dataset.tags || '';
          const has = (value) => tags.includes(`|${value}|`);
          if (skip !== 'familia' && state.familia.length && !state.familia.some(has)) return false;
          if (skip !== 'publico' && state.publico.length && !state.publico.some(has)) return false;
          const price = Number(item.dataset.price) / 100;
          if (state.min !== null && price < state.min) return false;
          if (state.max !== null && price > state.max) return false;
          if (state.stock && item.dataset.available !== 'true') return false;
          return true;
        }

        countOptions() {
          for (const option of this.querySelectorAll('[data-pl-opt]')) {
            const tag = `|${option.dataset.value}|`;
            const total = this.items.filter((item) => (item.dataset.tags || '').includes(tag)).length;
            option.hidden = total === 0;
          }
        }

        updateCounts(state) {
          for (const option of this.querySelectorAll('[data-pl-opt]')) {
            if (option.hidden) continue;
            const group = option.dataset.plOpt;
            const tag = `|${option.dataset.value}|`;
            const count = this.items.filter(
              (item) => (item.dataset.tags || '').includes(tag) && this.matches(item, state, group)
            ).length;
            const label = option.querySelector('.pl-f__count');
            if (label) label.textContent = count;
            option.classList.toggle('is-empty', count === 0 && !option.querySelector('input').checked);
          }
        }

        sortKey(state) {
          switch (state.orden) {
            case 'precio-asc':
              return (a, b) => a.dataset.price - b.dataset.price;
            case 'precio-desc':
              return (a, b) => b.dataset.price - a.dataset.price;
            case 'nombre-asc':
              return (a, b) => a.dataset.name.localeCompare(b.dataset.name);
            case 'nombre-desc':
              return (a, b) => b.dataset.name.localeCompare(a.dataset.name);
            case 'nuevos':
              return (a, b) => b.dataset.date - a.dataset.date;
            default:
              return (a, b) => a.dataset.index - b.dataset.index;
          }
        }

        apply(updateUrl) {
          if (!this.grid || !this.items.length) return;
          const state = this.state;
          const visible = this.items.filter((item) => this.matches(item, state)).sort(this.sortKey(state));
          const hidden = this.items.filter((item) => !visible.includes(item));
          const fragment = document.createDocumentFragment();
          visible.forEach((item, index) => {
            item.hidden = index >= this.shown;
            fragment.append(item);
          });
          hidden.forEach((item) => {
            item.hidden = true;
            fragment.append(item);
          });
          this.grid.append(fragment);

          const total = visible.length;
          const showing = Math.min(this.shown, total);
          for (const el of this.querySelectorAll('[data-pl-count]')) el.textContent = total;
          this.querySelector('[data-pl-empty]').hidden = total > 0;
          const moreWrap = this.querySelector('[data-pl-more-wrap]');
          moreWrap.hidden = total === 0;
          this.querySelector('[data-pl-more]').hidden = showing >= total;
          const text = this.querySelector('[data-pl-progress-text]');
          if (text) text.textContent = (this.strings.of || '[shown] / [total]').replace('[shown]', showing).replace('[total]', total);
          const bar = this.querySelector('[data-pl-progress]');
          if (bar) bar.style.width = `${total ? (showing / total) * 100 : 0}%`;

          this.updateCounts(state);
          this.renderChips(state);
          if (updateUrl) this.writeUrl(state);
        }

        renderChips(state) {
          const wrap = this.querySelector('[data-pl-chips]');
          const currency = this.strings.currency || '€';
          const chips = [
            ...state.familia.map((value) => ({ key: `familia:${value}`, label: value })),
            ...state.publico.map((value) => ({ key: `publico:${value}`, label: value })),
          ];
          if (state.min !== null) chips.push({ key: 'min', label: `${this.strings.chip_min || 'Min'} ${state.min} ${currency}` });
          if (state.max !== null) chips.push({ key: 'max', label: `${this.strings.chip_max || 'Max'} ${state.max} ${currency}` });
          if (state.stock) chips.push({ key: 'stock', label: this.strings.stock || 'Stock' });

          wrap.replaceChildren();
          for (const chip of chips) {
            const button = document.createElement('button');
            button.type = 'button';
            button.className = 'pl-coll__chip';
            button.dataset.plRemove = chip.key;
            button.textContent = chip.label;
            wrap.append(button);
          }
          if (chips.length) {
            const clear = document.createElement('button');
            clear.type = 'button';
            clear.className = 'pl-coll__chip-clear';
            clear.dataset.plClear = '';
            clear.textContent = this.querySelector('.pl-coll__clear')?.textContent || '×';
            wrap.append(clear);
          }
          wrap.hidden = chips.length === 0;

          const counter = this.querySelector('[data-pl-active-count]');
          counter.hidden = chips.length === 0;
          counter.textContent = chips.length;

          const badges = {
            familia: state.familia.length,
            publico: state.publico.length,
            precio: Number(state.min !== null) + Number(state.max !== null),
          };
          for (const badge of this.querySelectorAll('[data-pl-badge]')) {
            const n = badges[badge.dataset.plBadge] || 0;
            badge.textContent = n ? n : '';
          }
        }

        /* ---------- events ---------- */
        onChange = (event) => {
          if (!(event.target instanceof HTMLElement) || !event.target.closest('[data-pl-filters], .pl-coll__bar')) return;
          this.shown = this.step;
          this.apply(true);
        };

        onClick = (event) => {
          const target = event.target instanceof Element ? event.target : null;
          if (!target) return;
          if (target.closest('[data-pl-more]')) {
            this.shown += this.step;
            this.apply(false);
            return;
          }
          const remove = target.closest('[data-pl-remove]');
          if (remove) {
            const [group, value] = remove.dataset.plRemove.split(/:(.*)/s);
            if (group === 'min') this.querySelector('[data-pl-min]').value = '';
            else if (group === 'max') this.querySelector('[data-pl-max]').value = '';
            else if (group === 'stock') this.querySelector('input[name="stock"]').checked = false;
            else {
              for (const input of this.querySelectorAll(`input[name="${group}"]`)) {
                if (input.value === value) input.checked = false;
              }
            }
            this.shown = this.step;
            this.apply(true);
            return;
          }
          if (target.closest('[data-pl-clear]')) {
            for (const input of this.querySelectorAll('[data-pl-filters] input')) {
              if (input.type === 'checkbox') input.checked = false;
              else input.value = '';
            }
            this.shown = this.step;
            this.apply(true);
            return;
          }
          if (target.closest('[data-pl-open-filters]')) this.toggleFilters(true);
          else if (target.closest('[data-pl-close-filters]')) this.toggleFilters(false);
        };

        onKeydown = (event) => {
          if (event.key === 'Escape' && this.classList.contains('is-open')) this.toggleFilters(false);
          if (event.key === 'Enter' && event.target.matches?.('[data-pl-min], [data-pl-max]')) {
            event.preventDefault();
            event.target.dispatchEvent(new Event('change', { bubbles: true }));
          }
        };

        toggleFilters(open) {
          this.classList.toggle('is-open', open);
          this.querySelector('[data-pl-open-filters]')?.setAttribute('aria-expanded', String(open));
          const scrim = this.querySelector('.pl-coll__scrim');
          if (scrim) scrim.hidden = !open;
          document.documentElement.classList.toggle('pl-coll-lock', open);
          if (open) this.querySelector('.pl-coll__close')?.focus();
          else this.querySelector('[data-pl-open-filters]')?.focus({ preventScroll: true });
        }
      }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["pl-countdown"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('pl-countdown')) {
    customElements.define(
      'pl-countdown',
      class extends HTMLElement {
        connectedCallback() {
          this.end = Date.parse(this.dataset.end);
          if (Number.isNaN(this.end)) return;
          this.tick();
          this.timer = setInterval(() => this.tick(), 1000);
        }

        disconnectedCallback() {
          clearInterval(this.timer);
        }

        tick() {
          let rest = Math.max(0, Math.floor((this.end - Date.now()) / 1000));
          const values = { d: Math.floor(rest / 86400) };
          rest -= values.d * 86400;
          values.h = Math.floor(rest / 3600);
          rest -= values.h * 3600;
          values.m = Math.floor(rest / 60);
          values.s = rest - values.m * 60;
          for (const el of this.querySelectorAll('[data-unit]')) {
            el.textContent = String(values[el.dataset.unit]).padStart(2, '0');
          }
          if (this.end <= Date.now()) {
            clearInterval(this.timer);
            if (this.dataset.hide === 'true') this.closest('.pl-countdown')?.setAttribute('hidden', '');
          }
        }
      }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["pl-product-tabs"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('pl-tabs')) {
    customElements.define(
      'pl-tabs',
      class extends HTMLElement {
        connectedCallback() {
          this.abort = new AbortController();
          const { signal } = this.abort;
          this.addEventListener('click', this.onClick, { signal });
          document.addEventListener('shopify:block:select', this.onBlockSelect, { signal });
          const tabs = this.tabs;
          this.select(tabs.find((tab) => tab.getAttribute('aria-expanded') === 'true') || tabs[0], false);
          this.setAttribute('data-ready', '');
        }

        disconnectedCallback() {
          this.abort?.abort();
        }

        get tabs() {
          return [...this.querySelectorAll(':scope > [data-pl-tab]')];
        }

        select(tab, focus) {
          if (!tab) return;
          for (const other of this.tabs) {
            const active = other === tab;
            other.setAttribute('aria-expanded', String(active));
            const panel = document.getElementById(other.getAttribute('aria-controls'));
            if (panel) panel.hidden = !active;
          }
          if (focus) tab.focus({ preventScroll: true });
        }

        onClick = (event) => {
          const tab = event.target instanceof Element ? event.target.closest('[data-pl-tab]') : null;
          if (tab && tab.parentElement === this) this.select(tab, false);
        };

        onBlockSelect = (event) => {
          const tab = event.target instanceof Element ? event.target.closest('[data-pl-tab]') : null;
          if (tab && tab.parentElement === this) this.select(tab, false);
        };
      }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["pl-recommendations"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('pl-recs')) {
    customElements.define(
      'pl-recs',
      class extends HTMLElement {
        connectedCallback() {
          if (this.loaded || !this.dataset.url || this.dataset.url.includes('product_id=&')) return;
          this.loaded = true;
          const load = () => this.load();
          if ('IntersectionObserver' in window) {
            this.observer = new IntersectionObserver(
              (entries) => {
                if (entries.some((entry) => entry.isIntersecting)) {
                  this.observer.disconnect();
                  load();
                }
              },
              { rootMargin: '600px 0px' }
            );
            this.observer.observe(this);
          } else {
            load();
          }
        }

        disconnectedCallback() {
          this.observer?.disconnect();
        }

        async load() {
          try {
            const response = await fetch(this.dataset.url);
            if (!response.ok) return;
            const doc = new DOMParser().parseFromString(await response.text(), 'text/html');
            const grid = doc.querySelector('[data-pl-recs-grid]');
            if (!grid || Number(grid.dataset.count) === 0) return;
            this.querySelector('[data-pl-recs-grid]')?.replaceWith(document.adoptNode(grid));
          } catch (error) {
            console.warn('[pl-recs] Could not load recommendations', error);
          }
        }
      }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["pl-reviews"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('pl-reviews-summary')) {
    customElements.define(
      'pl-reviews-summary',
      class extends HTMLElement {
        connectedCallback() {
          const section = this.closest('.pl-section') || document;
          const ratings = [...section.querySelectorAll('.pl-review[data-rating]')].map((card) => Number(card.dataset.rating));
          if (!ratings.length) return;
          const average = ratings.reduce((sum, value) => sum + value, 0) / ratings.length;
          const lang = document.documentElement.lang || 'es';
          this.querySelector('[data-avg]').textContent = average.toLocaleString(lang, { minimumFractionDigits: 1, maximumFractionDigits: 1 });
          this.querySelector('[data-count]').textContent = (this.dataset.countText || '[count]').replace('[count]', ratings.length);
          const rounded = Math.round(average);
          this.querySelectorAll('[data-stars] svg').forEach((star, index) => star.classList.toggle('pl-stars__off', index >= rounded));
          this.hidden = false;
        }
      }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
